import api from 'api/api'
import { toast } from 'react-toastify'

export const GET_RECENT_PRODUCTS = '[POS] GET RECENT PRODUCTS'

export function getRecentProductsAction(storeId) {
  const request = api.get(`/pos/recent-products`, { params: { limit: 30 } })
  return (dispatch) => {
    dispatch({ type: GET_RECENT_PRODUCTS, payload: { loading: true } })
    request.then((response) => {
      dispatch({ type: GET_RECENT_PRODUCTS, payload: { data: response.data.data } })
    }).catch(error => {
      toast.error('Error al cargar productos recientes')
      console.log(GET_RECENT_PRODUCTS, error)
    }).finally(() => {
      dispatch({ type: GET_RECENT_PRODUCTS, payload: { loading: false } })
    })
  }
}
